module.exports = __webpack_public_path__ + "static/media/gameUniformDesignHuman.982b8aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignHuman.png
// module id = 2545
// module chunks = 0